import { validateEmail, validatePhone, validateString } from 'avilatek-utils';
import { User } from '../../models';

interface ValidateFormInput {
  user: Partial<User>;
  update: boolean;
  requiredDni?: boolean;
}

export function validateUserForm({
  user,
  update = true,
  requiredDni = true,
}: ValidateFormInput): string {
  const { firstName, lastName, email, phone, dni, dniType, password } = user;

  if (!validateString(firstName) || String(firstName).length > 127) {
    return 'Su nombre es inválido';
  }

  if (!validateString(lastName) || String(lastName).length > 127) {
    return 'Su apellido es inválido';
  }

  if (!email || !validateEmail(email)) {
    return 'Su correo electrónico es inválido';
  }

  if (!validatePhone(phone) || String(phone).length > 12) {
    return 'Su teléfono es inválido';
  }

  if (
    requiredDni &&
    (!dni ||
      Number(dni) < 0 ||
      String(dni).includes('.') ||
      String(dni).includes(','))
  ) {
    return 'Su número de identificación es inválido';
  }

  if (String(dni).length > 8 && dniType === 'V') {
    return 'Su número de identificación es inválido, debe de tener menos de 8 caracteres';
  }

  if (!update) {
    if (!password || String(password).length < 12) {
      return 'La contraseña debe contener al menos 12 caracteres';
    }

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/;
    if (!passwordRegex.test(password)) {
      return 'La contraseña debe contener al menos una letra mayúscula, una letra minúscula, un número y un carácter especial';
    }
  }

  return '';
}
